import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { RenderedService } from '../../rendered.service';
import { EnvironmentService, ScaffoldTypes } from '@services/environment.service';
import { UserService } from '@services/user.service';
import { CourseService } from '@scaffold/services/course.service';
import { FormControl } from '@angular/forms';
import { ItemsService } from '@scaffold/services/items.service';
import { NotificationsService } from '@services/notifications.service';

@Component({
  selector: 'scaffold-user-instance-select',
  templateUrl: './user-instance-select.component.html',
  styleUrls: ['./user-instance-select.component.scss']
})
export class UserInstanceSelectComponent
  extends BaseScaffoldComponent
  implements OnInit {
  instances = [];
  selectedInstances = [];
  userData: any;
  user: any;
  types = ScaffoldTypes;
  currentUser: any;
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private environmentService: EnvironmentService,
    private usersService: UserService,
    private courseService: CourseService,
    private itemsService: ItemsService,
    private notifications: NotificationsService
  ) {
    super(cdr, renderedService);
  }
  ngOnInit(): void {
    this.environmentService.getInstanceDetails(this.info.environment_id).subscribe((instanceData) => {
      this.instances = instanceData.instances;
      this.instances.forEach((inst, index) => {
        this.courseService.get(`roles?output=dataonly&mode=list&key_values=name,title&sub_domain=${inst.sub_domain}&environment=${inst.environment}`).subscribe((data: any) => {
          let roleData
          if (data.id) {
            roleData = [data];
          } else if (data.listItems) {
            roleData = data.listItems;
          } else if (data.push) {
            roleData = data;
          }
          else {
            roleData = [];
          }
          inst.roles = roleData.map(role => { return { name: role.data.name, title: role.data.title } });
        });
      });
      this.usersService.getRoleDetails().subscribe((data: any) => {
        this.currentUser = data;

        console.log('currentUser', this.currentUser);
        this.usersService.getUser(this.info.id).subscribe((data: any) => {
          this.user = data;
          if (this.instances.length === 1) {
            let instance = this.instances[0];
            this.usersService.getUserByCognito(data.data.cognito_username, instance.sub_domain, instance.environment).subscribe((userData: any) => {
              this.userData = userData;
              this.selectedInstances = [
                this.getInstanceUser(instance)
              ];
              this.cdr.detectChanges();
            });
          } else {
            console.log('user', this.user);
            let proms = [];
            this.instances.forEach(instance => {
              proms.push(this.usersService.getUserByCognito(this.user.data.cognito_username, instance.sub_domain, instance.environment).toPromise());
            })
            Promise.all(proms).then((data) => {
              console.log('data', this.user.id, data);
              this.selectedInstances = data.map(instance => {
                if (instance.listItems?.length > 0) {
                  instance = instance.listItems[0];
                }
                if (this.user.id === instance.id) {
                  this.userData = instance;
                }
                return this.getInstanceUser(instance);
              });
              console.log('this.selectedInstances', this.selectedInstances);
              this.cdr.detectChanges();
            });
          }
        });
      });
    });
  }

  getInstanceUser(instance) {
    console.log('-----------------------Check current', instance, this.user.data.cognito_username, this.currentUser);
    return {
      id: instance.id,
      role: new FormControl({ value: instance.data?.role, disabled: instance?.data?.cognito_username === this.currentUser.data.cognito_username }),
      active: new FormControl({ value: instance.id ? true : false, disabled: instance?.data?.cognito_username === this.currentUser.data.cognito_username }),
      can_add: instance.body !== 'User not authorized'
    };
  }

  updateInstances(index) {
    console.log('userData', this.userData);
    let instance = this.instances[index];
    let selectedInstance = this.selectedInstances[index];
    selectedInstance.updating = true;
    console.log('instance', instance);
    console.log('selectedInstance', selectedInstance.active.touched, selectedInstance);
    let event, data;
    if (selectedInstance.active.touched) {
      if (selectedInstance.id && !selectedInstance.active.value) {
        console.log('delete');
        event = "delete";
        this.usersService.deleteUserData(selectedInstance.id, instance.sub_domain, instance.environment).subscribe((data) => {
          this.notifications.popNotification('', `Successfully Removed`)
          this.usersService.getUserByCognito(this.userData.data.cognito_username, instance.sub_domain, instance.environment).subscribe((userData: any) => {
            this.selectedInstances[index] = this.getInstanceUser(userData);
            this.update();
          });
          console.log(event, data);
        });
      }
      else if (!selectedInstance.id && selectedInstance.active.value) {
        console.log('add', selectedInstance.role.value);
        event = "add";
        data = Object.assign(this.userData.data, { role: selectedInstance.role.value });
        data.role = selectedInstance.role.value;
        this.itemsService.createData(`/users`, { data }, ['sub_domain=' + instance.sub_domain, 'environment=' + instance.environment]).subscribe((data) => {
          this.usersService.getUserByCognito(this.userData.data.cognito_username, instance.sub_domain, instance.environment).subscribe((userData: any) => {
            this.selectedInstances[index] = this.getInstanceUser(userData);
            this.update();
          });
          console.log(event, data);
        });
      } else {
        selectedInstance.role.reset(selectedInstance.role.value);
        selectedInstance.active.reset(selectedInstance.active.value);
        selectedInstance.updating = false;
      }
    }
    else if (selectedInstance.id && selectedInstance.active.value && selectedInstance.role.touched) {
      event = "update";
      data = { role: selectedInstance.role.value };
      this.itemsService.saveViewData(`/users/${selectedInstance.id}`, { data }, ['sub_domain=' + instance.sub_domain, 'environment=' + instance.environment]).subscribe((data) => {
        this.notifications.popNotification('', data.updated ? `Successfully Updated` : `Error Updating: ${data.errorMessage || ''}`)
        this.usersService.getUserByCognito(this.userData.data.cognito_username, instance.sub_domain, instance.environment).subscribe((userData: any) => {
          this.selectedInstances[index] = this.getInstanceUser(userData);
          this.update();
        });
      });
    } else {
      selectedInstance.role.reset(selectedInstance.role.value);
      selectedInstance.active.reset(selectedInstance.active.value);
      selectedInstance.updating = false;
    }
  }

  formatType(type) {
    return this.types.find(t => t.type === type)?.title
  }

  update() {
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 100);
  }

}
